(function () {
    "use strict";

    // @ngInject
    function NonUsaWarningControllerCtor($scope, $injector, $modalInstance, $timeout, moment,
                                         AnalyticsService, ModalService, OnboardingService, UsersManager,
                                         clickSource) {
        this.constructor.$super.call(this, $scope, $injector);
        this._objectType = 'NonUsaWarningController';

        this.AnalyticsService = AnalyticsService;
        this.AnalyticsService.trackPageView(this, 'non usa warning modal');

        this.modalInstance = $modalInstance;
        this.OnboardingService = OnboardingService;
        this.UsersManager = UsersManager;
        this.ModalService = ModalService;
        this.moment = moment;
        this.clickSource = clickSource;

    }

    Controllers.NonUsaWarningController = Class(Controllers.BaseController, {
        constructor: NonUsaWarningControllerCtor,

        cancelModal: function cancelModal(){
            this.modalInstance.dismiss();
        },
        openIntakeForm: function openIntakeForm(clickSource){
            this.OnboardingService.openInProductIntakeForm(clickSource, true);
            this.modalInstance.dismiss();

        }
    });
}());
